const pluralize = require('pluralize')

const listOrCreate = (entity) => {
  if (!entity) { return '' }
  return '/' + pluralize(entity)
}

const showOrEdit = (entity, id) => {
  if (!entity) { return '' }
  return '/' + pluralize(entity) + '/' + id
}

export default {
  index: (entity = null) => {
    return listOrCreate(entity)
  },

  show: (entity = null, id) => {
    return showOrEdit(entity, id)
  },

  create: (entity = null) => {
    return listOrCreate(entity)
  },

  edit: (entity = null, id) => {
    return showOrEdit(entity, id)
  },

  delete: (entity = null, id) => {
    return showOrEdit(entity, id)
  }
}



// WEBPACK FOOTER //
// ./src/utils/apiRoutes.js